// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTile.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var PagingModel = require('share/components/controls/DataGrid/helpers/Izenda.PagingModel');
  var ReportPartTypeManager = require('Izenda.ReportPartTypeManager');
  var moment = require('moment');
  var uiState = require('logic/Izenda.UiState');
  var convertToDateTimeFormat = require('share/utils/Izenda.ConvertToDateTimeFormat');

  const {
    isEmpty,
    map,
    omit,
    isNil,
    flow,
    get,
    last,
    reject,
    compact,
    defaults,
    omitBy,
    getOr,
    toPairs,
    head,
    lowerCase,
    orderBy,
    slice,
    capitalize
  } = require('lodash/fp');

  function ReportPartSelection() {
    var colSortReportDirs = {
      reportname: 'DESC'
    };
    var colSortReportPartDirs = {
      title: 'DESC'
    };
    var props = {
      // for paginator of report table
      pageInfo: new PagingModel(colSortReportDirs),
      // for paginator of report part table
      reportPartPageInfo: new PagingModel(colSortReportPartDirs),
      criteria: {
        reportName: '',
        createdBy: '',
        createdDateFrom: '',
        createdDateTo: '',
        lastEditedBy: '',
        lastEditedDateFrom: '',
        lastEditedDateTo: ''
      },
      selectedReport: null,
      selectedReportPart: null,
      reportCollection: [],
      selectedCategory: null,
      selectedSubCategory: null,
      categoryCollection: [],
      subCategoryCollection: [],
      searchStatus: false,
      isGlobal: false, // true/ false/ null
      displayCriteria: {
        isGlobal: null, // 1/ 0/ null
        selectedCategory: null,
        selectedSubCategory: null,
        reportName: '',
        createdBy: '',
        createdDateFrom: '',
        createdDateTo: '',
        lastEditedBy: '',
        lastEditedDateFrom: '',
        lastEditedDateTo: ''
      },
      reportPartCollection: function() {
        return this.selectedReport && this.selectedReport.reportPart;
      },
      totalReportPart: function() {
        return getOr(0, 'length', this.reportPartCollection);
      },
      currentPageReportPartCollection: function() {
        var sortData = flow(omitBy(isEmpty), toPairs)(this.reportPartPageInfo.colSortDirs);
        var sortKey = map(head, sortData);
        var sortDirection = map(flow(last, lowerCase), sortData);
        var startItem = (this.reportPartPageInfo.pageIndex - 1) * this.reportPartPageInfo.pageSize;
        var endItem = startItem + this.reportPartPageInfo.pageSize;

        return flow(orderBy(sortKey, sortDirection), slice(startItem, endItem))(this.reportPartCollection);
      },
      tenantId: function() {
        return uiState.getTenantId();
      }
    };

    m.extendObservable(this, props);

    this.isGlobalObserve = m.observe(
      this.displayCriteria,
      'isGlobal',
      function() {
        this.clearCategory();
      }.bind(this)
    );
    this.selectedCategoryObserve = m.observe(
      this.displayCriteria,
      'selectedCategory',
      function() {
        this.clearSubCategory();
      }.bind(this)
    );
  }

  /**
   * Cancel the observer
   */
  ReportPartSelection.prototype.destroy = function() {
    this.isGlobalObserve();
    this.selectedCategoryObserve();
  };

  /**
   * apply display criteria to become real criteria
   * @method applyDisplayCritria
   * @return {[type]}            [description]
   */
  ReportPartSelection.prototype.applyDisplayCriteria = function() {
    m.transaction(
      function() {
        var isGlobal = this.displayCriteria.isGlobal;
        this.isGlobal = isNil(isGlobal) ? isGlobal : !!isGlobal;
        this.selectedCategory = this.displayCriteria.selectedCategory;
        this.selectedSubCategory = this.displayCriteria.selectedSubCategory;
        this.pageInfo.setPageIndex(1);
        this.reportPartPageInfo.setPageIndex(1);
        this.criteria = omit(['selectedCategory', 'selectedSubCategory'], this.displayCriteria);
      }.bind(this)
    );
  };

  /**
   * Clear selected category
   */
  ReportPartSelection.prototype.clearCategory = function() {
    this.displayCriteria.selectedCategory = null;
  };

  /**
   * Clear selected sub-category
   */
  ReportPartSelection.prototype.clearSubCategory = function() {
    this.displayCriteria.selectedSubCategory = null;
  };

  /**
   * build query object to get list report
   * @method buildSearchReportQuery
   * @return {json}               JSON object use for api
   */
  ReportPartSelection.prototype.buildSearchReportQuery = function(excludeIds) {
    this.pageInfo.buildSortOrder();
    return {
      isGlobal: this.isGlobal,
      subcategoryid: this.selectedSubCategory,
      categoryId: this.selectedCategory,
      tenantId: this.tenantId,
      pageSize: this.pageInfo.pageSize,
      pageIndex: this.pageInfo.pageIndex,
      sortOrders: this.pageInfo.sortOrders,
      excludeIds: excludeIds,
      criteria: flow(
        toPairs,
        map(function(item) {
          return {
            key: item[0],
            value: item[1],
            operation: 1
          };
        }),
        reject(flow(get('value'), isEmpty)),
        compact
      )(this.criteria)
    };
  };

  /**
   * read list of category from API
   * @method readListCategory
   * @param  {[type]}         result [description]
   */
  ReportPartSelection.prototype.readListCategory = function(result) {
    this.categoryCollection = result;
  };

  /**
   * read list of sub category from api
   * @method readListSubCategory
   * @param  {[type]}            result [description]
   */
  ReportPartSelection.prototype.readListSubCategory = function(result) {
    this.subCategoryCollection = result;
  };

  /**
   * get criteria from display criteria
   * @method getCriteria
   * @param  {[type]}    key [description]
   * @return {[type]}        [description]
   */
  ReportPartSelection.prototype.getCriteria = function(key) {
    return this.displayCriteria[key];
  };

  /**
   * update criteria to display criteria
   * @method setCriteria
   * @param  {[type]}    key   [description]
   * @param  {[type]}    value [description]
   */
  ReportPartSelection.prototype.setCriteria = function(key, value) {
    this.displayCriteria[key] = value;
  };

  /**
   * set selected report part
   * @method setSelectedReportPart
   * @param  {reportPart}              reportPart Select report part
   */
  ReportPartSelection.prototype.setSelectedReportPart = function(reportPart) {
    m.transaction(
      function() {
        this.selectedReportPart = reportPart;
      }.bind(this)
    );
  };

  /**
   * set selected report
   * @method setSelectedReport
   * @param  {JSON}          report Selected report
   */
  ReportPartSelection.prototype.setSelectedReport = function(report) {
    m.transaction(
      function() {
        this.selectedReport = report;
        this.selectedReportPart = null;
        this.reportPartPageInfo.pageIndex = 1;
        this.reportPartPageInfo.setTotalRecords(getOr(0, 'length', report.reportPart));
      }.bind(this)
    );
  };

  /**
   * list of report receive from api
   * @method readListReport
   * @param  {result}       result Result object from api
   */
  ReportPartSelection.prototype.readListReport = m.action(function(result) {
    this.searchStatus = true;
    this.selectedReport = null;
    this.selectedReportPart = null;
    this.reportCollection = map(function(report) {
      report.reportPart = map(function(item) {
        var typeConfig = ReportPartTypeManager.getReportPartType(item.reportPartContent.type);
        var typeInfo = {
          typeIcon: typeConfig.icon,
          reportPartTypeName: capitalize(typeConfig.key)
        };

        return defaults(item, typeInfo);
      }, report.reportPart);
      report.created = convertToDateTimeFormat(uiState.currentUser.dateFormat, report.created);
      report.modified = convertToDateTimeFormat(uiState.currentUser.dateFormat, report.modified);
      return report;
    }, result.result);
    this.pageInfo.setTotalRecords(result.total);
  });

  module.exports = ReportPartSelection;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Dashboard/Izenda.ReportPartSelection.js